import Postes from '@/views/configuration/dictionnaire/poste/pages/Poste';

export default [
  {
    path: '/configuration/dictionnaire/poste',
    name: 'configuration_dic_poste',
    component: Postes,
    meta: {
      auth: true,
      module: 'configuration',
      permission: 'access configuration',
    },
  },
];
